
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import routes from './router/config';
import MessageBar, { useMessageBar } from './components/feature/MessageBar';
import { createContext, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { configInfo } from './services/setting';
import { setConfigInfo } from './store/settingsSlice';

// 创建消息上下文
const MessageContext = createContext<ReturnType<typeof useMessageBar> | null>(null);

// 导出消息Hook供其他组件使用
export const useMessage = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessage must be used within MessageProvider');
  }
  return context;
};

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  const messageBar = useMessageBar();
  const dispatch = useDispatch();

  useEffect(() => {
    configInfo().then((res: any) => {
      if (res.status === 1) {
        dispatch(setConfigInfo(res.data));
      }
    });
  }, [dispatch]);

  return (
    <MessageContext.Provider value={messageBar}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="App">
          <AppRoutes />
          {/* 全局消息栏 */}
          <MessageBar 
            messages={messageBar.messages} 
            onRemoveMessage={messageBar.removeMessage} 
          />
        </div>
      </BrowserRouter>
    </MessageContext.Provider>
  );
}

export default App;
